import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'
import AnimatedHeading from 'components/animated-heading-host-services'

class ServicesOne extends React.Component {


    shouldComponentUpdate() {
        return false
    }
      

    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #000;            
            background-size: cover;
            padding: 100px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 10px 0 20px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
          }
        `

        const ServiceContainer = styled.div`
            background-color: rgba(0,0,0,.9);
            padding: 60px 0;
        `


        const ServiceElement = styled.div`
            margin-bottom: 20px;
            text-align: center;
            padding: 40px;
            border-radius: 20px;
            transition: .2s;
            &:hover {
                background-color: #000;
                box-shadow: 0 28px 60px rgb(193, 235, 24, .4);
                transform: translateY(-10px);
            }
        `
         const ServiceHeading = styled.h3`
            font-size: 30px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
        `
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin: auto auto 10px auto;        
         `
        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `        

        const Text = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #ffffff;
            padding-bottom: 30px;
            text-align: left;          
        `        

        const ServiceList = styled.ul`
            padding: 0;
            margin: 11px 0 0 0;
        `

        const ServiceListElement = styled.li`
            list-style: none;
            color: #a6a6a6;
            font-weight: 300;
            font-size: 17px;
            font-family: roboto,sans-serif;
            text-align: left;
            margin: 5px 0px;
            &::before {
                display: inline-block;
                content: '';
                border-radius: 2.5px;
                height: 5px;
                width: 5px;
                margin-right: 10px;
                background-color:#78c91c;
                position: relative;
                bottom: 2.5px;
            }
        `
        

        return(
            <Section>
                <ServiceContainer>
                    <Container>
                        <AnimatedHeading text="Características de los" />
                        <AnimatedHeading text="Servidores Dedicados" />
                        <AnimatedHeading text="NO administrados" />

                        <Text>
                            Un servidor dedicado no administrado es el lienzo en blanco perfecto para tus ambiciones digitales. Con poder,
                            control y flexibilidad sin límites, es la opción preferida para aquellos que buscan llevar su presencia en línea
                            a nuevas alturas.
                        </Text>
                        <Text>
                            ¿Estás listo para tomar las riendas?</Text>
                        <Text>
                            Explora el mundo de los servidores dedicados y da vida a tus proyectos con la libertad que siempre has deseado.
                            ¡El futuro digital te espera!
                        </Text>

                        <Row>
                            <Col md={4}>
                                
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image1} alt="Servidores Dedicados no gestionados" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Control total
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceList>
                                            <ServiceListElement>
                                                Tú decides cada configuración y ajuste.
                                            </ServiceListElement>
                                            <ServiceListElement>
                                                Ideal para usuarios con experiencia técnica.
                                            </ServiceListElement>
                                        </ServiceList>
                                    </ServiceElement>
                                
                            </Col>
                            <Col md={4}>
                                
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image2} alt="Servidor dedicado barato" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Costos más bajos
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceList>
                                            <ServiceListElement>
                                                Sin tarifas adicionales por servicios de administración.
                                            </ServiceListElement>
                                            <ServiceListElement>
                                                Paga solo por lo que necesitas.
                                            </ServiceListElement>
                                        </ServiceList>
                                    </ServiceElement>
                                
                            </Col>
                            <Col md={4}>
                                
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image3} alt="Servidores dedicados Colombia" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Flexibilidad extrema
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceList>
                                            <ServiceListElement>
                                                Personaliza el servidor según las necesidades de tu proyecto.
                                            </ServiceListElement>
                                            <ServiceListElement>
                                                Libérate de restricciones con recursos exclusivos.
                                            </ServiceListElement>
                                        </ServiceList>
                                    </ServiceElement>
                                
                            </Col>
                            <Col md={4}>
                                
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image4} alt="Servidores dedicados en Pereira" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Recursos garantizados
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceList>
                                            <ServiceListElement>
                                                Garantizamos todos los recursos ofrecidos al 100%
                                            </ServiceListElement>
                                            <ServiceListElement>
                                                Aprovisionamiento inmediato, sin demoras innecesarias.
                                            </ServiceListElement>
                                        </ServiceList>
                                    </ServiceElement>
                                
                            </Col>
                            <Col md={4}>
                                
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image5} alt="Servior dedicado SSD" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Seguridad reforzada
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceList>
                                            <ServiceListElement>
                                                Minimiza riesgos al no compartir recursos con otros usuarios.
                                            </ServiceListElement>
                                            <ServiceListElement>
                                                Implementa medidas de seguridad personalizadas para proteger tu información.
                                            </ServiceListElement>
                                        </ServiceList>
                                    </ServiceElement>
                                
                            </Col>
                            <Col md={4}>
                                
                                    <ServiceElement>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image6} alt="Servidor dedicado HDD" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Potencia sin límites
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceList>
                                            <ServiceListElement>
                                                Disfruta de recursos dedicados para un rendimiento máximo.
                                            </ServiceListElement>
                                            <ServiceListElement>
                                                Ideal para sitios web con tráfico intenso y aplicaciones exigentes.
                                            </ServiceListElement>
                                        </ServiceList>
                                    </ServiceElement>
                                
                            </Col>
                        </Row>
                    </Container>
                </ServiceContainer>
            </Section>
        )
    }

}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image1: file(relativePath: { eq: "icons/preferences.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/money.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/ram.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image4: file(relativePath: { eq: "icons/cpu.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image5: file(relativePath: { eq: "icons/protected.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image6: file(relativePath: { eq: "icons/redundancy.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }         
        }
      `}
        render={(data) => {            
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            const image4 = getImage(data.image4.childImageSharp.gatsbyImageData);
            const image5 = getImage(data.image5.childImageSharp.gatsbyImageData);
            const image6 = getImage(data.image6.childImageSharp.gatsbyImageData);            
            return <ServicesOne data={data} image1={image1} image2={image2} image3={image3} image4={image4} image5={image5} image6={image6}{...props} />;
        }}
    />
  );
  
  export default Iconos;
